import { OrderCreatePartner, OrderCreatePoint, TerminalItem } from 'schema'

import { TOrderCreateFormData } from '../../types'
import { OrderGuestCreateFormData } from '../OrderGuestCreatePage/types'

const transformCustomer = () => ({
  company: {
    name: '',
    inn: undefined,
    kpp: undefined
  },
  customerId: '',
  type: OrderCreatePartner.type.LEGAL
})

interface OrderGuestRedirectCreatePoint extends OrderCreatePoint {
  terminal: TerminalItem
}

const transformPoint = (point: OrderGuestRedirectCreatePoint): OrderGuestRedirectCreatePoint => {
  const { addressDetail, isCourier, terminal } = point

  if (!addressDetail) {
    return {
      terminal,
      terminalId: terminal.id,
      addressDetail: {
        address: terminal.address,
        comment: undefined,
        fiasId: '',
        latitude: terminal.latitude,
        longitude: terminal.longitude
      },
      isCourier
    } as OrderGuestRedirectCreatePoint
  }

  return {
    addressDetail: addressDetail || undefined,
    terminalId: terminal?.id || '',
    isCourier: Boolean(isCourier),
    terminal
  } as OrderGuestRedirectCreatePoint
}

export const transform = (data: OrderGuestCreateFormData): TOrderCreateFormData => {
  const { cargo, departurePoint, destinationPoint, departureDate, cargoType, cargoTotal, operation } = data

  const customerForm = transformCustomer()
  const departurePointForm = departurePoint ? transformPoint(departurePoint) : undefined
  const destinationPointForm = destinationPoint ? transformPoint(destinationPoint) : undefined

  return {
    cargo,
    cargoTotal,
    cargoType,
    comment: undefined,
    customer: customerForm,
    departureDate,
    departurePoint: departurePointForm,
    destinationPoint: destinationPointForm,
    operation
  }
}
